import { render, staticRenderFns } from "./LossHeader.vue?vue&type=template&id=7420ae8b&scoped=true&"
import script from "./LossHeader.vue?vue&type=script&lang=ts&"
export * from "./LossHeader.vue?vue&type=script&lang=ts&"
import style0 from "./LossHeader.vue?vue&type=style&index=0&id=7420ae8b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7420ae8b",
  null
  
)

export default component.exports